import type { Messages } from "../types";

export const messages: Messages = {
  shared: {
    title: "Fielmann Clientskont",
    tabs: {
      login: "Aloggen",
      signup: "Kont erstellen",
      ariaLabel: "Authentifikatioun",
    },
    languageSwitcher: {
      label: "Sprooch auswielen",
    },
    password: {
      show: "Passwuert weisen",
      hide: "Passwuert verstoppen",
    },
    header: {
      logoAriaLabel: "Fielmann",
    },
    footer: {
      ariaLabel: "Fousszeil",
      customerService: "Clientsservice",
      legalNotice: "Impressum",
      dataProtection: "Dateschutz",
    },
    loading: {
      ariaLabel: "Ee Moment, w.e.g. ...",
      content: "D'Inhalter gi gelueden.",
    },
    genericError:
      "Et ass e Feeler opgetrueden. Probéier et w.e.g. méi spéit nach eng Kéier.",
  },
  login: {
    subtitle: "Logg dech mat denger E-Mail-Adress an dengem Passwuert an.",
    form: {
      emailLabel: "E-Mail-Adress *",
      passwordLabel: "Passwuert *",
      forgotPassword: "Passwuert vergiess?",
      submitButton: "Aloggen",
      credentialError: "D'E-Mail-Adress an d'Passwuert passen net zesummen.",
    },
  },
  signup: {
    subtitle: {
      before: "Profitéier vun de ",
      highlight: "Virdeeler",
      after: " a stell däi Fielmann Clientskonto op.",
    },
    benefits: {
      popoverHeading: "Deng Virdeeler:",
      closeLabel: "Zoumaachen",
      items: {
        orders:
          "All deng Fielmann Bestellungen inklusiv Bestellstatus op ee Bléck.",
        visionValues:
          "Deng Siichtwäerter fir déi nächst Bestellung iwwerhuelen.",
        appointments: "Rendez-vouse buchen a verwalten.",
        reorders: "Ganz einfach online nobestellen.",
      },
    },
    form: {
      firstNameLabel: "Virnumm *",
      lastNameLabel: "Familljennumm *",
      emailLabel: "E-Mail-Adress *",
      passwordLabel: "Passwuert *",
      passwordRepeatLabel: "Passwuert widderhuelen *",
      submitButton: "Kont erstellen",
      errorTitle: "De Kont konnt net erstallt ginn.",
      errorMessage:
        "Iwwerpréif w.e.g. deng Angaben oder probéier et méi spéit nach eng Kéier.",
    },
    consents: {
      requiredError: "Gëff w.e.g. déi néideg Zoustëmmung.",
      unavailableError:
        "Et ass e Feeler opgetrueden. Probéier et w.e.g. méi spéit nach eng Kéier.",
      required: {
        headline: "Zoustëmmung fir d'Clientskonto",
        subline:
          "Fir datt mir dir all d'Inhalter an dengem Clientskonto weise kënnen (z. B. Akeef oder Rendez-vousen), brauche mir deng Zoustëmmung.",
      },
      optional: {
        headline: "Wëlls du personaliséiert Reklamm kréien?",
        subline:
          "Du hues de Choix: Wann s du zoustëmms, kriss du Offeren an Informatiounen, déi op dech zougeschnidde sinn. Ouni Zoustëmmung kanns du däi Clientskonto ouni personaliséiert Reklamm benotzen.",
      },
    },
  },
  emailVerification: {
    subtitle: "Du kanns dech net aloggen?",
    alertTitle: "Bestäteg fir d'éischt deng E-Mail-Adress.",
    alertBody:
      "Bestäteg w.e.g. fir d'éischt deng E-Mail-Adress, fir däi Fielmann Kont z'aktivéieren.",
    alertSpamHint: "Du fënns d'E-Mail net? Kuck och an dengem Spam-Dossier no.",
    resendButton: "E-Mail nach eng Kéier ufroen",
    backToLogin: "Zeréck bei d'Umeldung",
  },
  resetPasswordRequest: {
    subtitle: "Hues du däi Passwuert vergiess?",
    body: "Gëff w.e.g. d'E-Mail-Adress an, mat där s du däi Kont erstallt hues. Mir schécken dir e Link, mat deem s du däi Passwuert ganz einfach zerécksetze kanns.",
    emailLabel: "E-Mail-Adress *",
    submitButton: "Link ufroen",
    backToLogin: "Zeréck bei d'Umeldung",
    banner: {
      closeAria: "Zoumaachen",
      rateLimit: {
        title: "E-Mail ze dacks ugefrot",
        body: "Iwwerpréif w.e.g. deng Inbox an däi Spam-Dossier, fir d'E-Mail zum Zerécksetze vun dengem Passwuert ze fannen.",
        waitHint:
          "Du fënns se trotzdem net? Waart w.e.g. ee Moment – vläicht kënnt d'E-Mail nach un.",
      },
      error: {
        title: "Schécken net gelongen",
        body: "Probéier et w.e.g. méi spéit nach eng Kéier.",
      },
    },
  },
  resetPasswordEmail: {
    success: {
      heading: "E-Mail fir d'Passwuert zeréckzesetze geschéckt.",
      body: "Mir hunn dir eng E-Mail geschéckt, fir däi Passwuert zeréckzesetzen. Kuck w.e.g. an denger Inbox no.",
      spamHint:
        "Du fënns d'E-Mail net? Kuck am beschten och an dengem Spam-Dossier no.",
    },
    restart: {
      hint: "Wann s du d'E-Mail nach ëmmer net fënns, kanns du de Virgang nach eng Kéier starten. Vläicht hues du eng aner E-Mail-Adress benotzt.",
      button: "Nach eng Kéier probéieren",
    },
    error: {
      heading: "Schécken net gelongen",
      body: "Probéier et w.e.g. méi spéit nach eng Kéier.",
      retryButton: "Nach eng Kéier probéieren",
      rateLimitBody:
        "Ze vill Versich. Waart w.e.g. e puer Minutten, ier s du et nach eng Kéier probéiers.",
    },
  },
  setPassword: {
    subtitle: "Du kanns elo däi Passwuert festleeën.",
    passwordLabel: "Passwuert *",
    passwordRepeatLabel: "Passwuert widderhuelen *",
    submitButton: "Passwuert späicheren",
    backToLogin: "Bei d'Umeldung",
    successTitle: "Däi Passwuert gouf erfollegräich gespäichert.",
    successRedirectBody: "Du gëss elo op eis Startsäit weidergeleet.",
    successRedirectLoginHint:
      "Do kanns du dech mat dengem neie Passwuert aloggen.",
    successWaitHint: "Ee Moment, w.e.g.",
  },
  resetPasswordError: {
    expired: {
      heading: "Dëse Link ass ofgelaf.",
      body: "De Link fir däi Passwuert zeréckzesetzen ass net méi gülteg. Géi zeréck op d'Startsäit a klick beim Aloggen op „Passwuert vergiess?“, fir en neie Link unzefroen.",
    },
    used: {
      heading: "Dëse Link gouf schonn eng Kéier benotzt.",
      body: "Mat dësem Link gouf d'Passwuert schonn zeréckgesat. Wann s du däi Passwuert nach eng Kéier ännere wëlls, géi zeréck op d'Startsäit a klick beim Aloggen op „Passwuert vergiess?“, fir en neie Link unzefroen.",
    },
    generic: {
      heading: "Dëse Link ass ongülteg.",
      body: "De Link konnt net benotzt ginn. Géi zeréck op d'Startsäit a klick beim Aloggen op „Passwuert vergiess?“, fir en neie Link unzefroen.",
    },
    backToHome: "Zeréck op d'Startsäit",
  },
  toasts: {
    missingRequiredFields:
      "Fëll w.e.g. all déi obligatoresch Felder aus, déi nach feelen, fir weiderzemaachen.",
  },
  validation: {
    passwordRequired: "Gëff w.e.g. e Passwuert an.",
    passwordRepeatRequired: "Gëff w.e.g. d'Passwuert nach eng Kéier an.",
    firstNameTooLong: "De Virnumm däerf net méi laang wéi 30 Zeeche sinn.",
    firstNameRequired: "Gëff w.e.g. e Virnumm an.",
    firstNameInvalidFormat: "Gëff w.e.g. e gültege Virnumm an.",
    lastNameTooLong: "De Familljennumm däerf net méi laang wéi 30 Zeeche sinn.",
    lastNameRequired: "Gëff w.e.g. e Familljennumm an.",
    lastNameInvalidFormat: "Gëff w.e.g. e gültege Familljennumm an.",
    emailTooLong: "D'E-Mail-Adress ass ze laang.",
    emailRequired: "Gëff w.e.g. eng E-Mail-Adress an.",
    emailInvalidFormat: "Gëff w.e.g. eng gülteg E-Mail-Adress an.",
    passwordMatchesEmail:
      "D'Passwuert däerf net d'selwecht sinn ewéi d'E-Mail-Adress.",
    passwordMismatch: "D'Passwierder stëmmen net iwwereneen.",
  },
  passwordRequirements: {
    minimumLength: "Op d'mannst 10 Zeechen",
    mixedCase: "Op d'mannst ee Grouss- an ee Klengbuchstaf",
    hasNumber: "Op d'mannst eng Zuel",
    specialCharactersAllowed: "Spezialzeeche sinn erlaabt (z. B. !@#$%^&*)",
  },
};
